export default {
  apiKey: 'AIzaSyDUxrHrtA89vWFAHYvbIxo6SsIV3hGL_d8',
  authDomain: 'lantechhub.firebaseapp.com',
  databaseURL: 'https://lantechhub.firebaseio.com',
  projectId: 'lantechhub',
  storageBucket: 'lantechhub.appspot.com',
  messagingSenderId: '12685700472'
}



// WEBPACK FOOTER //
// ./src/firebaseRef.js